import React from 'react';

import { css } from '@emotion/react';

import { ThumbnailCTAProps } from '../../types';
import ShareButtonMedium from '../Button/ShareButtonMedium';
import WatchButtonMedium from '../Button/WatchButtonMedium';

const popupBtnWrap = css`
  display: flex;
  margin-top: 10px;
  & .shareContainer {
    margin-left: 10px;
  }
`;
const ThumbnailCTA: React.FC<ThumbnailCTAProps> = ({
  watchCallback,
  shareItems,
  cardDetails
}) => {
  return (
    <div css={popupBtnWrap}>
      <WatchButtonMedium watchCallback={watchCallback} />
      <ShareButtonMedium
        shareItems={shareItems}
        fromThumbnail={true}
        cardDetails={cardDetails}
      />
    </div>
  );
};

export default ThumbnailCTA;
